import styled from 'styled-components';

import { body } from '@constants/fonts';

import { FontWeight } from '../../theme/typography';

export const TimelineWrapper = styled.div<{ isSharing?: boolean }>`
  position: relative;
  box-sizing: border-box;
  width: 100%;
  margin-top: 50px;
  &:after {
    content: '';
    position: absolute;
    width: 2px;
    background-color: ${({
      isSharing,
      theme: {
        palette: { info, primary },
      },
    }) => (isSharing ? info.dark : primary.main)};
    opacity: 0.5;
    top: -25px;
    bottom: -25px;
    left: 50%;
    margin-left: -1px;
    ${(props) => props.theme.breakpoints.down('md')} {
      &:after {
        left: 31px;
      }
    }
  }
  ${(props) => props.theme.breakpoints.down('md')} {
    &:after {
      left: 31px;
    }
  }
`;

export const TimelineContainerLeft = styled.div`
  padding: 0 40px 0 0;
  position: relative;
  background-color: inherit;
  width: 50%;
  left: 0;
  box-sizing: border-box;

  &:after {
    content: '';
    position: absolute;
    width: 8px;
    height: 8px;
    right: -10px;
    background-color: ${({ theme }) => theme.palette.info.dark};
    border: 6px solid ${({ theme }) => theme.palette.info.dark};
    top: 7px;
    border-radius: 50%;
    z-index: 1;
  }

  ${(props) => props.theme.breakpoints.down('md')} {
    width: 100%;
    padding-left: 70px;
    padding-right: 0px;

    &:after {
      left: 21px;
    }
  }
`;

export const TimelineContainerRight = styled.div`
  padding: 0 0 0 40px;
  position: relative;
  background-color: inherit;
  width: 50%;
  right: calc(-50% - 1px);
  box-sizing: border-box;

  &:after {
    content: '';
    position: absolute;
    width: 8px;
    height: 8px;
    background-color: ${({ theme }) => theme.palette.info.dark};
    border: 6px solid ${({ theme }) => theme.palette.info.dark};
    top: 7px;
    border-radius: 50%;
    z-index: 1;
    left: -11px;
  }

  ${(props) => props.theme.breakpoints.down('md')} {
    width: 100%;
    padding-left: 70px;
    // padding-right: 25px;
    left: 0%;

    &:after {
      left: 21px;
    }
  }
`;

export const TimelineContent = styled.div<{ alignRight?: boolean }>`
  position: relative;
  box-sizing: border-box;
`;

export const Header = styled.div<{ isSharing?: boolean }>`
  position: absolute;
  left: calc(50% - 27px);
  top: -19px;
  height: 54px;
  width: 54px;
  line-height: 54px;
  text-align: center;
  color: ${({ theme }) => theme.palette.primary.contrastText};
  font-size: 18px;
  font-family: ${body};
  font-weight: 600;
  background-color: ${({
    isSharing,
    theme: {
      palette: { info, primary },
    },
  }) => (isSharing ? info.dark : primary.main)};
  border-radius: 50px;

  ${(props) => props.theme.breakpoints.down('md')} {
    left: 10px;
    top: -10px;
    height: 40px;
    width: 40px;
    line-height: 40px;
    font-size: 15px;
    font-weight: ${FontWeight.Light};
  }
`;
